import { Dialog, DialogActions, DialogContent, Typography } from "@mui/material"
import type { FC } from "react"

import { Button } from "@/components/common/Button"
import DialogHeader from "@/components/common/Modals/DialogHeader"

const ERROR_TITLE = "Status Cannot be Changed"

interface ProductInventoryLotStatusErrorDialogProps {
  message: string
  onClose: () => void
}

export const ProductInventoryLotStatusErrorDialog: FC<ProductInventoryLotStatusErrorDialogProps> = ({
  message,
  onClose,
}) => (
  <Dialog
    open
    onClose={onClose}
    maxWidth='sm'
    fullWidth
    PaperProps={{ sx: { minWidth: 520 } }}
    data-testid='product-inventory-lot.status-error-dialog'
  >
    <DialogHeader title={ERROR_TITLE} onClose={onClose} />
    <DialogContent className='p-10'>
      <Typography data-testid='product-inventory-lot.status-error-dialog.message' className='text-gray-700'>
        {message}
      </Typography>
    </DialogContent>
    <DialogActions className='justify-end px-10 pb-10'>
      <Button
        appearance='contained'
        onClick={onClose}
        data-testid='product-inventory-lot.status-error-dialog.close-button'
      >
        Close
      </Button>
    </DialogActions>
  </Dialog>
)
